import { render, staticRenderFns } from "./CreateBookmarkForm.vue?vue&type=template&id=6ff888db&scoped=true&"
import script from "./CreateBookmarkForm.vue?vue&type=script&lang=js&"
export * from "./CreateBookmarkForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateBookmarkForm.vue?vue&type=style&index=0&id=6ff888db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff888db",
  null
  
)

export default component.exports